import { type LucideIcon, PlugZap } from 'lucide-react';

export type Resource = {
  slug: string;
  title: string;
  description: string;
  icon: LucideIcon;
  notionUrl: string;
};

// The Notion pages below must be published via Share -> Publish in Notion.
export const RESOURCES: Resource[] = [
  {
    slug: 'integration-status',
    title: 'CMS Integration Status',
    description:
      'Live status of features (task pull, note sync, entity sync, doc sync) across all supported CMS integrations.',
    icon: PlugZap,
    notionUrl:
      'https://hypnotic-wombat-c3b.notion.site/ebd//319e7a32200280339456eac55fc085a7',
  },
];
